import { Card, Checkbox, Form, message, Modal } from 'antd'
import Cookies from 'js-cookie'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const rtllSettings = { expires: 365 }

const SettingsModal = (props) => {
    const { showSettingsModal, setShowSettingsModal } = props
    const [initialValues, setInitialValues] = useState(JSON.parse(Cookies.get('RTLSS_SETTINGS')))
    const [form] = Form.useForm()
    const { t } = useTranslation()

    useEffect(() => {
        setInitialValues(JSON.parse(Cookies.get('RTLSS_SETTINGS')))
    }, [showSettingsModal])



    return (
        <Modal
            bodyProps={{
                style: {
                    marginBottom: '30px'
                }
            }}
            destroyOnClose
            title={'Calculator Settings'}
            open={showSettingsModal}
            onCancel={() => {
                setShowSettingsModal(false)
                form.resetFields()
            }}
            cancelText = {t('10021')} //  Cancel
            okText= {t('10126')} //  Apply Settings
            onOk={() => {
                let keys = Object.keys(form.getFieldsValue())
                let changed = keys.some((thisKey) => {
                    return form.getFieldValue(thisKey) !== initialValues[thisKey]
                })
                if (changed) {
                    Cookies.set('RTLSS_SETTINGS', JSON.stringify({ ...JSON.parse(Cookies.get('RTLSS_SETTINGS')), ...(form.getFieldsValue()) }), rtllSettings)
                    message.success('Settings saved to browser.')
                } else {
                    message.info('No changes on the settings were made.')
                    form.resetFields()
                }

                setShowSettingsModal(false)

            }}
        >
            <Form

                form={form}
                name='settingsForm'
                initialValues={initialValues}>
                <Form.Item
                    style={{ marginBottom: '12px' }}
                    label= {t('10127')} //  Hide Disclaimer
                    help= {t('10125')} //   When checked, this setting will hide the disclaimer window that appears when you try to submit the calculation.    
                    name={'hide_confirmation'}
                    valuePropName='checked'>
                    <Checkbox />
                </Form.Item>
            </Form>

        </Modal>
    )
}

export default SettingsModal